import { render, staticRenderFns } from "./IndexMenutwo.vue?vue&type=template&id=0e8867d4&scoped=true&"
import script from "./IndexMenutwo.vue?vue&type=script&lang=js&"
export * from "./IndexMenutwo.vue?vue&type=script&lang=js&"
import style0 from "./IndexMenutwo.vue?vue&type=style&index=0&id=0e8867d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8867d4",
  null
  
)

export default component.exports